import { BailTaxModel } from "./bail-tax.model";
import { BailLineModel } from "./bail-line.model";

export class BailModel {

    uid: string;
    invoiceUid: string;
    providerUid: string;
    providerName: string;
    date: Date;
    taxes: Array<BailTaxModel>;
    bailLine: Array<BailLineModel>;
    concept: string;
    base: number;
    total: number;
    expenseNumber: string;
    isInvoice: boolean;
    activityUid: string;
    activityName: string;
    fiscalYear: number;
    typePay: string;
    typePayBankAccount: string;
    efectivoId: string;
    partnersId: number;
    duration: number;

    constructor() {
        this.taxes = new Array<BailTaxModel>();
    }
}
